import useGetFeatureConfig from './useGetFeatureConfig';

export const useGetDefaultShortlistLimit = () => {
  const { data: featureConfigData } = useGetFeatureConfig();
  const DEFAULT_DAILY_SHORTLIST_LIMIT = 50;
  const DEFAULT_DAILY_VIP_SHORTLIST_LIMIT = 200;
  const DEFAULT_DAILY_SUBCRIPTION_SHORTLIST_LIMIT = 500;

  const defaultDailyCompanyLimitBalance =
    featureConfigData?.DEFAULT?.SHORTLIST_DAILY ??
    DEFAULT_DAILY_SHORTLIST_LIMIT;

  const defaultDailyVIPLimitBalance =
    featureConfigData?.VIP?.SHORTLIST_DAILY ??
    DEFAULT_DAILY_VIP_SHORTLIST_LIMIT;

  const defaultDailySubcriptionsLimitBalance =
    featureConfigData?.SUBSCRIPTION?.SHORTLIST_DAILY ??
    DEFAULT_DAILY_SUBCRIPTION_SHORTLIST_LIMIT;

  const defaultVIPShortlistQuotaBalance =
    featureConfigData?.VIP?.SHORTLIST_QUOTA;

  return {
    defaultDailyCompanyLimitBalance,
    defaultDailyVIPLimitBalance,
    defaultDailySubcriptionsLimitBalance,
    defaultVIPShortlistQuotaBalance,
  };
};
